import Swiper from 'swiper/dist/js/swiper';

export default {
  init() {
  },
  finalize() {
	  var wpoints = document.getElementsByClassName("hidden");
		var i;
		for (i = 0; i < wpoints.length; i++) {
			var waypoint = new Waypoint({
			element: wpoints[i],
			handler: function () {
				this.element.classList.toggle("visible");
			},
			offset: '100%'
			})
		}
		

		$(document).ready(function () {
      //initialize swiper when document ready
      var mySwiper = new Swiper('.swiper-container', {
        // Optional parameters
        autoplay: {
          delay: 1500,
        },
        speed: 1500,
      	direction: 'horizontal',
      	loop: true,
      	slidesPerView: '6',
        spaceBetween: 20,
        centeredSlides: true,
				slideToClickedSlide: true,
				disableOnInteraction: false,
				breakpoints: {
					1024: {
						slidesPerView: 4,
						spaceBetween: 20
					},
					768: {
						slidesPerView: 2,
						spaceBetween: 20
					}
				}
			});
		});
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js